import React from 'react';
import Sidebar from '../component/layout/sidebar';
import Header from '../component/layout/header';
import { useState } from 'react';
import Exhibitorscontent from '../sections/Exhibitors_management';


const Exhibitors = () => {
         const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    return (
                 <section className='main-dashboard-container'>            
            <Sidebar isOpen={isSidebarOpen}  /> 
            <section className='container-right-info'>
                    <section className='header-container'>
                        <Header  onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}  />
                    </section>

               
                      <Exhibitorscontent />


            </section>
    </section>
      );
}
 
export default Exhibitors;